import { DriverCopy } from './driverI18n';

function MenuIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}

export function DriverHeader({
  t,
  title,
  userName,
  onBack,
  onMenu,
}: {
  t: DriverCopy;
  title?: string;
  userName?: string;
  onBack?: () => void;
  onMenu?: () => void;
}) {
  return (
    <header className="header">
      <div className="header-top">
        {onBack ? (
          <button type="button" className="driver-back" onClick={onBack} aria-label={t.back}>
            ←
          </button>
        ) : (
          <div className="logo">
            <span className="logo-text">Cashalot</span>
            <span className="logo-edo">ЭДО</span>
          </div>
        )}
        {title ? <h1 className="driver-screen-title">{title}</h1> : <span />}
        {onMenu ? (
          <div className="driver-header-user">
            {userName ? <span className="driver-header-name">{userName}</span> : null}
            <button type="button" className="driver-icon-btn" onClick={onMenu} aria-label={t.menu} title={t.menu}>
              <MenuIcon />
            </button>
          </div>
        ) : (
          <span className="driver-header-spacer" />
        )}
      </div>
    </header>
  );
}
